'use client'

import { useEffect } from 'react'
import { reportWebViewRecovery } from '@/lib/webview-recovery'

/**
 * Emite a PostHog la muerte del render process del WebView del arranque anterior
 * (ver lib/webview-recovery.ts). Se dispara al estar listo el bridge de Capacitor:
 * antes, `isPluginAvailable('WebViewRecovery')` diría que no.
 *
 * En ese mismo commit `CookieConsentProvider` —hijo de este provider— inicializa
 * PostHog en modo native, y React vacía los efectos de los hijos antes que los del
 * padre, así que aquí ya está listo. Si aun así no lo estuviera, el informe NO se
 * consume y se reporta en el siguiente arranque en vez de perderse.
 *
 * Extraído de `CapacitorBridgeProvider` para no engordar la complejidad de ese
 * componente (Code Health), igual que `useReferralCaptureOnMount`.
 */
export function useWebViewRecoveryReport(isCapacitor: boolean): void {
  useEffect(() => {
    if (!isCapacitor) return

    void reportWebViewRecovery()
  }, [isCapacitor])
}
